import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Nos domaines", href: "#metiers", anchor: true },
  { label: "Nos réalisations", href: "#realisations", anchor: true },
  { label: "Notre approche", href: "/notre-approche", anchor: false },
  { label: "Contact", href: "/contact", anchor: false },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLink = (e: React.MouseEvent<HTMLAnchorElement>, link: { href: string; anchor: boolean }) => {
    e.preventDefault();
    setMenuOpen(false);
    if (!link.anchor) {
      navigate(link.href);
      return;
    }
    // anchor link: if on home, scroll; otherwise go home then scroll
    if (location.pathname === "/") {
      const el = document.querySelector(link.href);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/");
      setTimeout(() => {
        const el = document.querySelector(link.href);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 300);
    }
  };

  const handleContactClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setMenuOpen(false);
    if (location.pathname === "/") {
      document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/");
      setTimeout(() => {
        document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
      }, 300);
    }
  };

  return (
    <header className="fixed top-0 left-0 w-full z-50 bg-white border-b border-gray-100 transition-all duration-300">
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center cursor-pointer">
          <img
            src="https://static.readdy.ai/image/8892c16dc9d95083db2eef95f931ffc6/445e988713bd18b72503e524f616d428.png"
            alt="KS BTP Logo"
            className="h-12 w-auto object-contain"
          />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-7">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => handleLink(e, link)}
              className="text-base font-semibold text-gray-800 transition-colors cursor-pointer whitespace-nowrap hover:text-[#00a340]"
            >
              {link.label}
            </a>
          ))}
          <Link
            to="/devis"
            className="ml-2 px-5 py-2.5 rounded-md bg-[#00a340] text-white text-base font-bold whitespace-nowrap hover:bg-[#007a30] transition-colors cursor-pointer"
          >
            Demander un devis
          </Link>
        </nav>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden flex items-center justify-center w-9 h-9 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <i className={`text-xl text-gray-800 ${menuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-4 py-4 flex flex-col gap-3">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => handleLink(e, link)}
              className="text-sm font-medium text-gray-700 hover:text-[#00a340] cursor-pointer py-1"
            >
              {link.label}
            </a>
          ))}
          <Link
            to="/devis"
            className="mt-2 px-4 py-2 rounded-md bg-[#00a340] text-white text-sm font-semibold text-center whitespace-nowrap cursor-pointer"
            onClick={() => setMenuOpen(false)}
          >
            Demander un devis
          </Link>
        </div>
      )}
    </header>
  );
}
